import NsFormGroup from '@britishgasenergy/react-nucleus/dist/nuc-components/NsFormGroup';
import NsStandout from '@britishgasenergy/react-nucleus/dist/nuc-components/NsStandout';

import { useMaskPII } from 'hooks/useMaskPII';
import { NsTextInput } from 'components/common/ns-text-input/NsTextInput';
import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import { DirectDebitPlayBack } from './DirectDebitPlayBack';
import NsInputterEvent from 'components/common/ns-inputter/NsInputterEvent';

type DirectDebitCompanyFormProps = {
  handleChange: (event: NsInputterEvent) => void;
  details: {
    companyName?: string;
    companyRegistrationNumber?: string;
    firstName?: string;
    lastName?: string;
    birthDate?: string;
    paymentDate?: string;
    sortCode?: string;
    accountNumber?: string;
    address: {
      flatNumber?: string;
      houseNumber?: string;
      houseName?: string;
      addressLine1?: string;
      addressLine2?: string;
      postalTown?: string;
      county?: string;
      displayName?: string;
      postcode?: string;
    };
  };
};

export const DirectDebitCompanyForm = ({
  details,
  handleChange
}: DirectDebitCompanyFormProps) => {
  const { companyName, companyRegistrationNumber } = details;
  const { mask } = useMaskPII();
  const validation = [NsInputterValidations.isRequired];

  return (
    <>
      <DirectDebitPlayBack details={details} />
      <NsStandout decoration="cyan">
        <h5>It looks like you entered details belonging to a business</h5>
        <p>
          Please provide us with some additional details below or you can
          provide an alternative address above.
        </p>
      </NsStandout>
      <NsFormGroup legend="Company details" id="companyDetails">
        <p>
          Please fill in your company details exactly as they appear on your
          bank account.
        </p>
        <NsTextInput
          id="companyName"
          name="companyName"
          label="Company name"
          inputAttributes={mask}
          value={companyName ?? ''}
          onChange={handleChange}
          validation={validation}
          pattern="[\\p{L}\\d\\s\\-&'().,@£$€¥#:;+]{0,50}"
        />
        <NsTextInput
          id="companyRegistrationNumber"
          name="companyRegistrationNumber"
          label="Company registration number"
          inputAttributes={mask}
          value={companyRegistrationNumber ?? ''}
          onChange={handleChange}
          validation={validation}
          pattern="(SC|NI|OC|SO|NC|LP|SL|NL|RC|[0-9]{2})[0-9]{6}"
        />
      </NsFormGroup>
    </>
  );
};
